import { friendLinks, companyInfo } from './index.js';
export default {
  data() {
    return {
      friendLinks,
      companyInfo
    };
  },
  methods: {
    jumpToGov() {
      window.location.href = 'https://beian.miit.gov.cn/';
    }
  }
};